/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Agency {
  FDIC = "FDIC",
  NCUA = "NCUA",
  NONE = "NONE",
}

export enum AssetClass {
  AIRCRAFT = "AIRCRAFT",
  AUTO = "AUTO",
  BOAT = "BOAT",
  CRE = "CRE",
  HOME = "HOME",
  MARINE = "MARINE",
  MBL = "MBL",
  MOTORCYCLE = "MOTORCYCLE",
  REVOLVING = "REVOLVING",
  RV = "RV",
  SOLAR = "SOLAR",
  UNSECPERSONAL = "UNSECPERSONAL",
  WAREHOUSE = "WAREHOUSE",
}

export enum BidStatus {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum CollateralStatus {
  ADDITIONAL_QA_REQUIRED = "ADDITIONAL_QA_REQUIRED",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  RECEIVED = "RECEIVED",
  REJECTED = "REJECTED",
  REQUIRED = "REQUIRED",
}

export enum DealActionOptionType {
  APPROVE_BUYER = "APPROVE_BUYER",
  REJECT_BUYER = "REJECT_BUYER",
}

export enum DealBlocker {
  BOTH = "BOTH",
  BUYER = "BUYER",
  NEITHER = "NEITHER",
  SELLER = "SELLER",
}

export enum DealMessageAuthorRole {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum DealRole {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum DealStatus {
  BID_ACCEPTED = "BID_ACCEPTED",
  BID_REJECTED = "BID_REJECTED",
  BUYER_AND_SELLER_NDA = "BUYER_AND_SELLER_NDA",
  BUYER_NDA = "BUYER_NDA",
  BUYER_OFFER = "BUYER_OFFER",
  COMPLETE = "COMPLETE",
  DILIGENCE = "DILIGENCE",
  PENDING_SETTLEMENT = "PENDING_SETTLEMENT",
  REJECTED_INQUIRY = "REJECTED_INQUIRY",
  SELLER_INQUIRY = "SELLER_INQUIRY",
  SELLER_NDA = "SELLER_NDA",
  SELLER_REVIEW = "SELLER_REVIEW",
  WAIT_FOR_CUTOFF = "WAIT_FOR_CUTOFF",
  WAIT_FOR_WIRE_TRANSFER = "WAIT_FOR_WIRE_TRANSFER",
  WIRE_TRANSFER_CONFIRMED = "WIRE_TRANSFER_CONFIRMED",
  WIRE_TRANSFER_SENT = "WIRE_TRANSFER_SENT",
}

export enum DefaultAssumptionType {
  CDR = "CDR",
  SDA = "SDA",
}

export enum DiligenceBatchStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum DiligenceStatus {
  DESELECTED = "DESELECTED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING_DOCUMENTS = "PENDING_DOCUMENTS",
  REJECTED = "REJECTED",
  REVIEWED = "REVIEWED",
}

export enum ExecutionType {
  ALL_OR_NOTHING = "ALL_OR_NOTHING",
  BUYER_CHOICE = "BUYER_CHOICE",
}

export enum FileState {
  ERROR = "ERROR",
  ERROR_HEADER = "ERROR_HEADER",
  ERROR_PASSWORD = "ERROR_PASSWORD",
  NEEDS_MAPPING = "NEEDS_MAPPING",
  NEW = "NEW",
  PERSISTED = "PERSISTED",
  PERSISTING = "PERSISTING",
  PROCESSED = "PROCESSED",
  PROCESSING = "PROCESSING",
  READING_FILE_HEADERS = "READING_FILE_HEADERS",
  READY_TO_PERSIST = "READY_TO_PERSIST",
  READY_TO_PROCESS = "READY_TO_PROCESS",
}

export enum FileType {
  COLLATERAL_FILE = "COLLATERAL_FILE",
  DEAL_FILE = "DEAL_FILE",
  DQ_AND_CHARGE_OFF = "DQ_AND_CHARGE_OFF",
  LENDING_POLICY = "LENDING_POLICY",
  LISTING_FILE = "LISTING_FILE",
  LOAN_TAPE = "LOAN_TAPE",
  OTHER = "OTHER",
  SAMPLE_COLLATERAL = "SAMPLE_COLLATERAL",
  TERMS_DOCUMENT = "TERMS_DOCUMENT",
  TRANSACTION_DOCUMENT = "TRANSACTION_DOCUMENT",
}

export enum FilterOperator {
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUALS = "GREATER_THAN_OR_EQUALS",
  IS = "IS",
  IS_NOT = "IS_NOT",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUALS = "LESS_THAN_OR_EQUALS",
}

export enum FilterableField {
  account_id = "account_id",
  age_months = "age_months",
  amortization_term_months = "amortization_term_months",
  arm_index = "arm_index",
  arm_index_rate_bps = "arm_index_rate_bps",
  arm_margin_bps = "arm_margin_bps",
  asset_class = "asset_class",
  auto_original_value_cents = "auto_original_value_cents",
  balloon_term_months = "balloon_term_months",
  borrower_credit_score = "borrower_credit_score",
  city = "city",
  cra = "cra",
  current_balance_cents = "current_balance_cents",
  days_past_due = "days_past_due",
  dti_bps = "dti_bps",
  first_payment_date_seconds = "first_payment_date_seconds",
  first_rate_change_date_seconds = "first_rate_change_date_seconds",
  interest_only = "interest_only",
  interest_rate_bps = "interest_rate_bps",
  io_period_months = "io_period_months",
  irap_months = "irap_months",
  last_loan_tape_id = "last_loan_tape_id",
  last_loan_tape_name = "last_loan_tape_name",
  last_updated_date_seconds = "last_updated_date_seconds",
  lifetime_cap_rate_bps = "lifetime_cap_rate_bps",
  lifetime_floor_rate_bps = "lifetime_floor_rate_bps",
  listing_id = "listing_id",
  loan_terms_months = "loan_terms_months",
  ltv_bps = "ltv_bps",
  maturity_date_seconds = "maturity_date_seconds",
  next_payment_date_seconds = "next_payment_date_seconds",
  occupancy = "occupancy",
  original_balance_cents = "original_balance_cents",
  origination_date_seconds = "origination_date_seconds",
  payment_month = "payment_month",
  periodic_cap_rate_bps = "periodic_cap_rate_bps",
  postal_code = "postal_code",
  product = "product",
  purpose = "purpose",
  rap_months = "rap_months",
  remaining_loan_terms_months = "remaining_loan_terms_months",
  state = "state",
  status = "status",
}

/**
 * Status of a background job - maps to loan-management JobStatus
 */
export enum JobStatusEnum {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

/**
 * Type of background job - maps to loan-management JobType
 */
export enum JobType {
  OFFERING_CREATION = "OFFERING_CREATION",
  POOL_CREATION = "POOL_CREATION",
}

export enum ListingField {
  asset_class = "asset_class",
  company_id = "company_id",
  created_date_seconds = "created_date_seconds",
  execution_type = "execution_type",
  has_cra = "has_cra",
  loan_count = "loan_count",
  name = "name",
  origination_type = "origination_type",
  participation_rate = "participation_rate",
  pricing_rate_bps = "pricing_rate_bps",
  pricing_type = "pricing_type",
  provided_name = "provided_name",
  servicing_preference = "servicing_preference",
  t_current_balance_cents = "t_current_balance_cents",
  wa_borrower_credit_score = "wa_borrower_credit_score",
  wa_coupon_bps = "wa_coupon_bps",
  wa_current_balance_cents = "wa_current_balance_cents",
  wa_dti_bps = "wa_dti_bps",
  wa_loan_age_months = "wa_loan_age_months",
  wa_ltv_bps = "wa_ltv_bps",
  wa_remaining_loan_terms_months = "wa_remaining_loan_terms_months",
}

export enum ListingState {
  ACTIVE = "ACTIVE",
  DELETING = "DELETING",
  NEEDS_REFRESH = "NEEDS_REFRESH",
  NEW = "NEW",
  READY_TO_CREATE = "READY_TO_CREATE",
  REFRESHED = "REFRESHED",
  SCANNING = "SCANNING",
  TO_DELETE = "TO_DELETE",
}

export enum LoanField {
  account_id = "account_id",
  age_months = "age_months",
  amortization_term_months = "amortization_term_months",
  arm_index = "arm_index",
  arm_index_rate_bps = "arm_index_rate_bps",
  arm_margin_bps = "arm_margin_bps",
  asset_class = "asset_class",
  auto_original_value_cents = "auto_original_value_cents",
  auto_vin = "auto_vin",
  balloon_term_months = "balloon_term_months",
  borrower_credit_score = "borrower_credit_score",
  city = "city",
  cra = "cra",
  current_balance_cents = "current_balance_cents",
  dti_bps = "dti_bps",
  first_payment_date_seconds = "first_payment_date_seconds",
  first_rate_change_date_seconds = "first_rate_change_date_seconds",
  interest_only = "interest_only",
  interest_rate_bps = "interest_rate_bps",
  io_period_months = "io_period_months",
  irap_months = "irap_months",
  last_loan_tape_id = "last_loan_tape_id",
  last_loan_tape_name = "last_loan_tape_name",
  last_updated_date_seconds = "last_updated_date_seconds",
  lifetime_cap_rate_bps = "lifetime_cap_rate_bps",
  lifetime_floor_rate_bps = "lifetime_floor_rate_bps",
  loan_terms_months = "loan_terms_months",
  ltv_bps = "ltv_bps",
  maturity_date_seconds = "maturity_date_seconds",
  next_payment_date_seconds = "next_payment_date_seconds",
  occupancy = "occupancy",
  original_balance_cents = "original_balance_cents",
  origination_date_seconds = "origination_date_seconds",
  periodic_cap_rate_bps = "periodic_cap_rate_bps",
  postal_code = "postal_code",
  product = "product",
  property_description = "property_description",
  property_year = "property_year",
  purpose = "purpose",
  rap_months = "rap_months",
  remaining_loan_terms_months = "remaining_loan_terms_months",
  servicing_rate_bps = "servicing_rate_bps",
  state = "state",
}

/**
 * Login Method Enum
 */
export enum LoginMethod {
  NATIVE = "NATIVE",
  SSO = "SSO",
}

export enum NewsArticleField {
  category = "category",
  id = "id",
  publication_date_seconds = "publication_date_seconds",
  sentiment_label = "sentiment_label",
  sentiment_score = "sentiment_score",
  source = "source",
  subject = "subject",
  summary = "summary",
  url = "url",
}

export enum NewsSource {
  ABA = "ABA",
  CUNA = "CUNA",
  CU_TODAY = "CU_TODAY",
  FDIC = "FDIC",
  FEDERAL_RESERVE = "FEDERAL_RESERVE",
  MBA = "MBA",
  NCUA = "NCUA",
  OTHER = "OTHER",
  US_TREASURY = "US_TREASURY",
}

export enum NoteStatus {
  NEW = "NEW",
  NONE = "NONE",
  READ = "READ",
}

export enum OriginationType {
  DIRECT = "DIRECT",
  INDIRECT = "INDIRECT",
  INDIRECT_FINTECH = "INDIRECT_FINTECH",
  MIXED = "MIXED",
  N_A = "N_A",
}

export enum ParentType {
  COMPANY = "COMPANY",
  DEAL = "DEAL",
  LISTING = "LISTING",
}

export enum PerformanceClass {
  NON_PERFORMING = "NON_PERFORMING",
  PERFORMING = "PERFORMING",
  RE_PERFORMING = "RE_PERFORMING",
  SUB_PERFORMING = "SUB_PERFORMING",
}

export enum PrepaymentAssumptionType {
  CPR = "CPR",
  PSA = "PSA",
}

export enum PricingType {
  NONE = "NONE",
  PUBLISHED = "PUBLISHED",
  RESERVED = "RESERVED",
}

export enum ProductType {
  ARM = "ARM",
  FIXED = "FIXED",
}

export enum RateType {
  RiskFree = "RiskFree",
  Sofr = "Sofr",
}

/**
 * Status of a remittance tape upload in loan-service.
 * Source: loan-management/loan-service/internal/model/remittance.go RemittancesUploadStatus.
 */
export enum RemittancesUploadStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum ServicingPreference {
  NONE = "NONE",
  RELEASED = "RELEASED",
  RETAINED = "RETAINED",
}

export enum SortDirection {
  asc = "asc",
  desc = "desc",
}

export enum SortableField {
  account_id = "account_id",
  age_months = "age_months",
  asset_class = "asset_class",
  auto_original_value_cents = "auto_original_value_cents",
  bankruptcy = "bankruptcy",
  borrower_credit_score = "borrower_credit_score",
  charge_off = "charge_off",
  city = "city",
  current_balance_cents = "current_balance_cents",
  days_past_due = "days_past_due",
  dti_bps = "dti_bps",
  first_payment_date_seconds = "first_payment_date_seconds",
  first_rate_change_date_seconds = "first_rate_change_date_seconds",
  interest_cents = "interest_cents",
  interest_rate_bps = "interest_rate_bps",
  last_updated_date_seconds = "last_updated_date_seconds",
  loan_terms_months = "loan_terms_months",
  ltv_bps = "ltv_bps",
  maturity_date_seconds = "maturity_date_seconds",
  next_payment_date_seconds = "next_payment_date_seconds",
  original_balance_cents = "original_balance_cents",
  origination_date_seconds = "origination_date_seconds",
  payment_cents = "payment_cents",
  postal_code = "postal_code",
  principal_cents = "principal_cents",
  product = "product",
  remaining_loan_terms_months = "remaining_loan_terms_months",
  servicing_rate_bps = "servicing_rate_bps",
  starting_balance_cents = "starting_balance_cents",
  state = "state",
  tdr = "tdr",
}

/**
 * Types of stipulations a buyer can save to their carve
 */
export enum StipulationFieldName {
  bid_basis_points = "bid_basis_points",
  diligence_completion_date_seconds = "diligence_completion_date_seconds",
  min_net_yield_to_buyer_bps = "min_net_yield_to_buyer_bps",
  percent_collateral_diligence_bps = "percent_collateral_diligence_bps",
  servicing_rate_bps = "servicing_rate_bps",
  settlement_date_seconds = "settlement_date_seconds",
  transfer_amount = "transfer_amount",
}

export enum StipulationToggleName {
  has_diligence_completion_date_seconds = "has_diligence_completion_date_seconds",
  has_min_net_yield_to_buyer = "has_min_net_yield_to_buyer",
  has_percent_collateral_diligence = "has_percent_collateral_diligence",
  has_settlement_date_seconds = "has_settlement_date_seconds",
  is_servicing_retained = "is_servicing_retained",
}

export enum TimelineStatus {
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

export enum Uploader {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

/**
 * Add the UserScope and UserEntity type definitions
 */
export enum UserEntity {
  company = "company",
  listing = "listing",
}

export enum UserRole {
  authorized_signer = "authorized_signer",
  deal_manager = "deal_manager",
  deal_participant = "deal_participant",
  diligence_reviewer = "diligence_reviewer",
  marketplace_viewer = "marketplace_viewer",
  portfolio_manager = "portfolio_manager",
  portfolio_viewer = "portfolio_viewer",
  remittances_manager = "remittances_manager",
  remittances_viewer = "remittances_viewer",
  user_administrator = "user_administrator",
}

/**
 * Variance code identifying a specific anomaly type detected on a remittance record.
 */
export enum VarianceCode {
  BALANCE_EXCEEDS_ORIGINAL = "BALANCE_EXCEEDS_ORIGINAL",
  BALANCE_INCREASED = "BALANCE_INCREASED",
  DPD_OUT_OF_RANGE = "DPD_OUT_OF_RANGE",
  DPD_REVERSED = "DPD_REVERSED",
}

/**
 * Review lifecycle status of a detected variance.
 */
export enum VarianceStatus {
  ACKNOWLEDGED = "ACKNOWLEDGED",
  PENDING = "PENDING",
}

export interface AcceptBidInput {
  deal_id: string;
  bid_id: string;
}

export interface AddCollateralNoteInput {
  dealID: string;
  loanID: string;
  fileName: string;
  note: string;
  authorRole: DealMessageAuthorRole;
}

/**
 * Add a remittance note for a given account (remittance account id).
 */
export interface AddRemittanceNoteInput {
  offeringID: string;
  buyerCompanyID: string;
  accountID: string;
  note: string;
}

export interface AddWireDetailsNoteInput {
  dealID: string;
  fileName: string;
  note: string;
}

/**
 * Input for approving a remittance tape upload. Only the deal seller may approve; upload must be PENDING.
 */
export interface ApproveRemittanceRecordsInput {
  upload_id: string;
}

/**
 * Input for archiving multiple pools
 */
export interface ArchivePoolsInput {
  pool_ids: string[];
}

export interface AutoMapFieldsInput {
  columns: string[];
  sampleRows?: (string[] | null)[] | null;
  enums: string[];
  fileId?: string | null;
}

export interface CalculateBidPriceInput {
  deal_id: string;
  bid_basis_points: number;
  carve?: Filter[] | null;
  transfer_amount?: number | null;
}

export interface CollateralFileDownloadURLInput {
  dealID: string;
  loanID?: string | null;
  fileName: string;
}

export interface CollateralFileUploadURLInput {
  dealID: string;
  loanID?: string | null;
  fileName: string;
}

export interface ConfirmWireTransferInput {
  deal_id: string;
}

export interface CreateDealCarveInput {
  deal_id: string;
  name: string;
  carve: Filter[];
}

export interface CreateDealMessageInput {
  deal_id: string;
  message: string;
}

export interface CreateDiligenceNoteInput {
  diligence_id: string;
  note: string;
}

export interface DealMessageLastEvaluatedKeyInput {
  id: string;
  deal_id: string;
  created_time: string;
}

export interface DealMessagePaginationInput {
  sort_direction?: SortDirection | null;
  limit?: number | null;
  last_evaluated_key?: DealMessageLastEvaluatedKeyInput | null;
}

/**
 * Input types for the new Collateral File and Diligence AI handling.
 */
export interface DiligenceInput {
  dealId: string;
}

/**
 * Filter model that requires field_name and operator to be set.  Operand is the default, and only operand OR operandList can be set.  Not both!
 */
export interface Filter {
  field_name: FilterableField;
  operator: FilterOperator;
  operand?: string | null;
  operandList?: string[] | null;
}

/**
 * Input for getAccountRemittanceVariances: fetch variances for specific accounts within an upload.
 */
export interface GetAccountRemittanceVariancesInput {
  upload_id: string;
  account_ids: string[];
}

export interface GetCollateralReportUrlInput {
  dealId: string;
  zipFileName: string;
  versionId?: string | null;
}

export interface GetContractFileGetUrlInput {
  dealId: string;
  contractId: string;
  contractVersion: string;
}

export interface GetContractFilePostUrlInput {
  dealId: string;
  fileName: string;
  contentType?: string | null;
  contractId?: string | null;
}

/**
 * Input for getDealMonthRemittances.
 */
export interface GetDealMonthRemittancesInput {
  deal_id: string;
  payment_month: string;
}

/**
 * Input for getDealRemittanceSummaries: deal. Returns aggregated summaries per approved payment month.
 */
export interface GetDealRemittanceSummariesInput {
  deal_id: string;
}

export interface GetFileUuidInput {
  parentId?: string | null;
  fileType: FileType;
  fileName: string;
  s3VersionId: string;
  assetClass?: AssetClass | null;
  productType?: ProductType | null;
}

/**
 * Get remittance notes for a given account (remittance account id).
 */
export interface GetRemittanceNotesInput {
  offeringID: string;
  buyerCompanyID: string;
  accountID: string;
  limit?: number | null;
  paginationKey?: string | null;
}

export interface GetRemittanceTapePostUrlInput {
  deal_id: string;
  file_name: string;
  content_type: string;
  payment_month: string;
}

export interface GetSelectDiligenceStatusInput {
  deal_id: string;
  id: string;
}

/**
 * Input for getSingleMonthRemittanceRecords: deal, optional month, and either account_ids (batch) or filters (query), plus optional pagination.
 */
export interface GetSingleMonthRemittanceRecordsInput {
  deal_id: string;
  payment_month?: string | null;
  account_ids?: string[] | null;
  filters?: Filter[] | null;
  pagination?: Pagination | null;
}

/**
 * Input for querying remittance records by upload_id. Pagination is applied in the API layer (page_size, offset).
 */
export interface GetUploadRemittanceRecordsInput {
  upload_id: string;
  filters?: Filter[] | null;
  pagination?: Pagination | null;
  sort?: Sort | null;
}

export interface GetValidTermsInput {
  parentType: ParentType;
  parentId?: string | null;
  fieldNames: FilterableField[];
  filters?: Filter[] | null;
}

export interface HeaderMapInput {
  file_column: string;
  field: LoanField;
}

/**
 * Listing Filter model that requires field_name and operator to be set.  Operand is the default, and only operand OR operandList can be set.  Not both!
 */
export interface ListingFilter {
  field_name: ListingField;
  operator: FilterOperator;
  operand?: string | null;
  operandList?: string[] | null;
}

export interface ListingSort {
  sort_field?: ListingField | null;
  sort_direction?: SortDirection | null;
}

export interface MarkCollateralReviewCompleteInput {
  deal_id: string;
}

export interface MarkDiligenceAcceptedInput {
  deal_id: string;
  accepted: boolean;
}

export interface MarkDiligenceCompleteInput {
  deal_id: string;
}

export interface MarkReadRequest {
  notificationID: string;
}

export interface MarkSettlementCompleteInput {
  deal_id: string;
}

export interface MultipleCollateralFilesMetadataInput {
  dealID: string;
}

export interface NewsFilter {
  field_name: NewsArticleField;
  operator: FilterOperator;
  operand?: string | null;
  operandList?: string[] | null;
}

export interface NewsSort {
  sort_field?: NewsArticleField | null;
  sort_direction?: SortDirection | null;
}

/**
 * The pagination inputs.  Instead of an offset, we use a cursor to indicate where we want the page of results to start.
 */
export interface Pagination {
  page_size?: number | null;
  cursor_id?: string | null;
  cursor_sorted_value?: string | null;
  offset?: number | null;
}

/**
 * Input for rejecting a remittance tape upload. Only the deal seller may reject; upload must be PENDING.
 */
export interface RejectRemittanceRecordsInput {
  upload_id: string;
}

export interface RemoveCollateralFileRequest {
  dealID: string;
  loanID: string;
  fileName: string;
}

export interface RemoveWireDetailsFileInput {
  dealID: string;
  fileName: string;
}

export interface SaveSellerBidInput {
  deal_id: string;
  bid_id: string;
  seller_bid_basis_points: number;
  transfer_amount?: number | null;
}

export interface SaveWireDetailsPricesInput {
  dealID: string;
  cleanPriceCents?: Long | null;
  dirtyPriceCents?: Long | null;
}

export interface SelectDiligenceLoansInput {
  deal_id: string;
  loan_ids?: string[] | null;
  selection_filters?: Filter[] | null;
}

export interface SentWireTransferInput {
  deal_id: string;
}

/**
 * Input for setRemittanceWireDetails. Omitted fields are left untouched; providing a field overwrites the entire buyer or seller wire details map.
 */
export interface SetRemittanceWireDetailsInput {
  deal_id: string;
  payment_month: string;
  existing_version: number;
  buyer_wire_details?: WireDetailsInput | null;
  seller_wire_details?: WireDetailsInput | null;
  buyer_remittances_received?: boolean | null;
  seller_remittances_sent?: boolean | null;
}

export interface SetWireDetailsPricesVisibleInput {
  dealID: string;
}

export interface SingleCollateralFileMetadataInput {
  dealID: string;
  loanID: string;
  fileName: string;
}

export interface Sort {
  sort_field?: SortableField | null;
  sort_direction?: SortDirection | null;
}

export interface SubmitBidInput {
  deal_id: string;
  bid_basis_points: number;
  carve_id: string;
  document_ids?: string[] | null;
}

export interface SubmitReferralInput {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  company: string;
}

/**
 * Input for submitting a support request
 */
export interface SubmitSupportRequestInput {
  description: string;
  sessionId: string;
  url?: string | null;
  metadata?: JSONObject | null;
}

export interface UpdateCollateralStatusInput {
  dealID: string;
  loanID: string;
  fileName: string;
  newStatus: CollateralStatus;
}

export interface UpdateDealCarveInput {
  carve_id: string;
  deal_id: string;
  name?: string | null;
  carve?: Filter[] | null;
}

/**
 * Input for updateRemittanceVarianceStatus: acknowledge or revert a specific variance with optimistic locking.
 */
export interface UpdateRemittanceVarianceStatusInput {
  upload_id: string;
  account_id: string;
  variance_code: VarianceCode;
  status: VarianceStatus;
  note?: string | null;
  expected_version: number;
}

export interface UserManagementAddUserScopeRequest {
  userID?: string | null;
  username?: string | null;
  companyID: string;
  scopes: UserScopeInput[];
}

export interface UserManagementCreateUserRequest {
  username: string;
  userEmail: string;
  givenName: string;
  familyName: string;
  phoneNumber: string;
  companyID: string;
  roles: UserRole[];
}

export interface UserManagementGetUserRequest {
  userID?: string | null;
  username?: string | null;
}

export interface UserManagementListCompanyPermissionsRequest {
  companyID: string;
}

export interface UserManagementListCompanyUserPermissionsRequest {
  companyID: string;
}

export interface UserManagementRemoveUserFromCompanyRequest {
  userID: string;
  companyID: string;
}

export interface UserManagementUpdateUserInfoRequest {
  username: string;
  userEmail: string;
  givenName: string;
  familyName: string;
}

export interface UserManagementUpdateUserRolesRequest {
  userID?: string | null;
  username?: string | null;
  companyID: string;
  roles: UserRole[];
}

export interface UserManagementUpdateUserScopesRequest {
  userID?: string | null;
  username?: string | null;
  companyID: string;
  scopes: UserScopeInput[];
}

export interface UserScopeInput {
  entity: UserEntity;
  id: string;
  role: UserRole;
}

export interface WireDetailsFileDownloadURLInput {
  dealID: string;
  fileName: string;
}

export interface WireDetailsFileUploadURLInput {
  dealID: string;
  fileName: string;
}

/**
 * Wire details fields for input.
 */
export interface WireDetailsInput {
  account_name: string;
  account_number: string;
  bank_name: string;
  routing_number: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
